module.exports = __webpack_public_path__ + "static/media/ads-line.c7518734.png";